import React from "react";

/**
 * Brand headline: Montserrat Light setup + ExtraBold payoff.
 * One clear headline per section. Left-aligned.
 *
 * @param {string} light - Light (300) lead-in, e.g. "Find your"
 * @param {string} bold - ExtraBold (800) payoff, e.g. "support."
 * @param {"blue"|"white"|"blue-on-mist"} [tone] - Colour pairing
 * @param {boolean} [sunshinePayoff] - Sunshine colour on bold word (only on Spectrum Blue bg)
 * @param {"h1"|"h2"|"h3"} [as]
 */
const Headline = ({
  light,
  bold,
  tone = "blue",
  sunshinePayoff = false,
  as: Tag = "h2",
  className = "",
  children,
}) => {
  const toneClass =
    tone === "white"
      ? "text-white"
      : tone === "blue-on-mist"
        ? "text-spectrum-blue"
        : "text-spectrum-blue";

  const boldClass =
    sunshinePayoff && tone === "white"
      ? "text-sunshine font-extrabold"
      : "font-extrabold";

  return (
    <Tag
      className={`font-headline text-headline leading-[1.15] tracking-tight text-left ${toneClass} ${className}`}
    >
      {children ? (
        children
      ) : (
        <>
          {light && <span className="font-light">{light} </span>}
          {bold && <span className={boldClass}>{bold}</span>}
        </>
      )}
    </Tag>
  );
};

export default Headline;
